// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_3v64c","placeholder":"_1Efnm","dirty":"_30gBq"};